var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedeemButtonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3.25C11.5 4.76878 9.03757 6 6 6C2.96243 6 0.5 4.76878 0.5 3.25M11.5 3.25C11.5 1.73122 9.03757 0.5 6 0.5C2.96243 0.5 0.5 1.73122 0.5 3.25M11.5 3.25V10.75C11.5 12.2688 9.03757 13.5 6 13.5C2.96243 13.5 0.5 12.2688 0.5 10.75V3.25M11.5 3.25V5.75M0.5 3.25V5.75M11.5 5.75V8.25C11.5 9.76878 9.03757 11 6 11C2.96243 11 0.5 9.76878 0.5 8.25V5.75M11.5 5.75C11.5 7.26878 9.03757 8.5 6 8.5C2.96243 8.5 0.5 7.26878 0.5 5.75",
    stroke: "#120A8F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeemButtonIcon);
export default __webpack_public_path__ + "static/media/redeem-button-icon.98d8d0606459d625f884f8c41bbf338c.svg";
export { ForwardRef as ReactComponent };